import '@lottiefiles/lottie-player';

import Modal from '../../helpers/modal';
import { fadeIn, fadeOut, slideDown, slideUp } from '../../helpers/animations';

document.addEventListener('DOMContentLoaded', () => {
    document
        .querySelectorAll('.image-video-content .video-modal')
        .forEach((element) => {
            const openButtons = document.querySelectorAll(
                `[aria-controls="${element.id}"]`
            );
            const modal = new Modal(
                element.id,
                openButtons,
                'video-modal-close',
                'video-modal-inner',
                false
            );
            modal.addEventListener('close', () => {
                const iframe = element.querySelector('iframe');
                if (iframe && iframe.getAttribute('src')) {
                    iframe.setAttribute('data-src', iframe.getAttribute('src'));
                    iframe.setAttribute('src', iframe.getAttribute('data-src'));
                }
            });
            modal.init();
        });

    document.querySelectorAll('.video-transcript').forEach((element) => {
        const openButtons = document.querySelectorAll(
            `[aria-controls="${element.id}"]`
        );

        const allButtons = (callback) => {
            for (let i = 0; i < openButtons.length; i += 1) {
                callback(openButtons[i]);
            }
        };

        allButtons((button) => {
            button.addEventListener('click', () => {
                const isOpen = button.getAttribute('aria-expanded') === 'false';
                if (isOpen) {
                    slideDown(element, 0.3);
                    fadeIn(element, 0.3);
                    allButtons((b) => b.setAttribute('aria-expanded', 'true'));
                } else {
                    slideUp(element, 0.3);
                    fadeOut(element, 0.3);
                    allButtons((b) => b.setAttribute('aria-expanded', 'false'));
                }
            });
        });
    });
});
